// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".masonry-grid{grid-gap:var(--gap-x);grid-auto-rows:0;grid-template-columns:var(--template-columns)}.masonry-grid.hidden{display:none}@media (max-width:576px){.masonry-grid{grid-auto-rows:auto}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
